module.exports = __webpack_public_path__ + "static/media/bg2.336d7629.png";